export const FETCH_SYSTEM_PENDING = 'FETCH_SYSTEM_PENDING';
export const FETCH_SYSTEM_SUCCESS = 'FETCH_SYSTEM_SUCCESS';
export const FETCH_SYSTEM_ERROR = 'FETCH_SYSTEM_ERROR';
